export default __webpack_public_path__ + "static/media/Arte_Muro_Full_Body.51ee3385.png";